import { IForm } from 'core-components/classes/models/IForm'

export const renderPhoneCodeFn = ({ value, phoneCode }: IForm) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>{value}</div>
    <div>+{phoneCode}</div>
  </div>
)
